// Opens a PDF blob in a new tab; if the browser's popup blocker kills the
// tab (common when the fetch takes >5s after the click), falls back to a
// direct file download — anchor clicks are never popup-blocked.
export function openPdfBlob(data, filename = "documento.pdf") {
  const url = URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
  const win = window.open(url, "_blank");
  if (!win) {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
